<template>
  <div class="h-full" style="display: flex; " :style="{ justifyContent: flexStart ? 'start' : 'center' }">
    <div class="sign-field w-full h-full " :class="[bordered ? 'bordered': '', isMobile ? 'mobile' : '']" :style="{ maxWidth: maxWidth }">
      <div v-if="image" class="sign-image h-full" :style="{backgroundImage: image? `url(${image})`: ''}" @click="handleClickImage"></div>
<!--      <img v-if="image" :src="image" style="border: 0; height:80px;" @click="handleClickImage"/>-->
      <div v-else @click.stop="handleClick" style="width:100%; height: 100%; min-height:80px; min-width: 120px; display: flex; justify-content: center; align-items: center; color: #3c3c3c"><template v-if="!readonly">클릭하여<br>서명하기</template></div>

      <popup-sign-field
        v-model="showPopup"
        :image="image"
        :readonly="readonly"
        :useLoadSign="useLoadSign"
        @save="handleSave"
        @update="handleUpdate"
        @delete="handleDelete"/>
    </div>
  </div>
</template>

<script>
import PopupSignField from '@/popup/PopupSignField'
export default {
  name: 'SignField',
  components: {PopupSignField},
  props: {
    value: String,
    readonly: Boolean,
    // 테두리를 표시할지 여부
    bordered: {
      type: Boolean,
      default: true
    },
    flexStart: Boolean,
    maxWidth: {
      type: String,
      default: '250px'
    },
    // 내 서명 불러오기 사용 여부
    useLoadSign: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      image: this.value,
      showPopup: false,
      passHistoryBack: false,
    }
  },
  computed:{
    projectId () {
      return this.$route.params.proj_id
    },
    isMobile () {
      return this.$viewport.width < 768
    }
  },
  watch: {
    value (value) {
      this.image = value
    },
    image (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    moveMySignUpdate () {
      if (this.projectId) {
        window.location.href = `/project/${this.projectId}/mypage/info-update`
      } else {
        window.location.href = '/mypage/info-update'
      }
    },
    handleSave (value) {
      this.image = value
    },
    handleDelete () {
      if (confirm("삭제하시겠습니까?")) {
        this.image = ''
      }
    },
    handleClick () {
      this.showPopup = true
    },
    handleUpdate(imgSrc) {
      if (imgSrc === false) {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "알림",
            message: '등록된 서명이 없습니다.',
            useConfirm: true,
            confirmBtn: "개인서명관리 페이지로 이동",
            confirmFunction: () => this.moveMySignUpdate(),
          },
        });
        window.dispatchEvent(customAlert);
      } else {
        this.image = imgSrc;
      }
    },
    handleClickImage () {
      this.showPopup = true
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-field {
  display: grid;

  width: 100%;
  height: 100%;

  min-width: 120px;
  //max-width: 250px;
  min-height: 120px;


  img {
    width: 100%;
    height: 100%;

    display: inline-block;
    content: "";
    border-radius: 6px;
  }
  .sign-image {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  &.bordered {
    border: solid 1px #cdcdcd;
    border-radius: 6px;
  }

  &.mobile {
    max-width: 100%;
  }
}
</style>
